import { initReportMultiDataSourceRefactor } from "helpers/service_helper"
import React, { useEffect, useRef, useState } from "react"
import { Card, Spin, Empty, Flex, Typography, Button, Tag } from "antd"
import {
  FileTextOutlined,
  ExpandOutlined,
  CompressOutlined,
  ReloadOutlined,
  PrinterOutlined,
} from "@ant-design/icons"

import StiReport from "./MapForm.mrt"
import Localizations from "../../../locales/fa/fa.xml"
import { getApiUrlGasProjectFilesWithFileNumber } from "common/global"

const { Title, Text } = Typography

const MapForm = props => {
  const { model, lstGasProjectFiles, matches_sm } = props
  const viewerRef = useRef(null)
  const [isLoading, setIsLoading] = useState(true)
  const [isFullscreen, setIsFullscreen] = useState(false)
  const [hasError, setHasError] = useState(false)

  const packageInstallerModel = {
    FullName: "",
    CompanyName: "",
    Companycode: "",
  }

  const reportData = {
    GasProject: model?.gasProject,
    GasProjectCheckList: model?.gasProjectCheckList,
    GasProjectDetails: model?.gasProjectDetail,
    Engineer: model?.engineer,
    Executor: model?.gasProject?.executor,
    PackageInstaller: model?.gasProject?.packageInstaller || packageInstallerModel,
  }

  const toggleFullscreen = () => {
    const container = document.getElementById("mapFormWrapper")
    if (!isFullscreen) {
      if (container?.requestFullscreen) {
        container.requestFullscreen()
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      }
    }
    setIsFullscreen(!isFullscreen)
  }

  const reloadReport = () => {
    setIsLoading(true)
    setHasError(false)
    const container = document.getElementById("mapForm")
    if (container) container.innerHTML = ""
    initializeReport()
  }

  const initializeReport = () => {
    if (!reportData.GasProject) {
      setHasError(true)
      setIsLoading(false)
      return
    }

    const isoPlanFile = lstGasProjectFiles?.find(x => x.fileTypeEnum == 4)
    const isoPlanUrl = getApiUrlGasProjectFilesWithFileNumber(
      `${isoPlanFile?.folderName}/${isoPlanFile?.fileName}`,
      model.gasProject.fileNumber
    )

    // Clear previous viewer
    if (viewerRef.current) {
      const container = document.getElementById("mapForm")
      if (container) container.innerHTML = ""
    }

    // Initialize with delay
    const timer = setTimeout(() => {
      try {
        viewerRef.current = initReportMultiDataSourceRefactor(
          StiReport,
          reportData,
          Localizations,
          {
            isoPlanUrl: isoPlanUrl,
            assignEngUrl: `https://api.kurdvahedgas.ir/api/v1.0/Users/GetPhysicalFileS3Liara?path=Upload/UserFiles/${model.engineer.userId}/Assign.png`,
            assignExeUrl: `https://api.kurdvahedgas.ir/api/v1.0/Users/GetPhysicalFileS3Liara?path=Upload/UserFiles/${model.gasProject.executor.userId}/Assign.png`,
            workPermitNum: model.workPermitNum,
          },
          { 
            height: matches_sm ? "500px" : "850px", 
            width: "100%" 
          },
          "mapForm"
        )
        setIsLoading(false)
      } catch (error) {
        console.error("Report initialization error:", error)
        setHasError(true)
        setIsLoading(false)
      }
    }, 100)

    return timer
  }

  useEffect(() => {
    if (!model) return

    setIsLoading(true)
    const timer = initializeReport()

    return () => {
      clearTimeout(timer)
      if (viewerRef.current) {
        const container = document.getElementById("mapForm")
        if (container) container.innerHTML = ""
      }
    }
  }, [model, lstGasProjectFiles])

  // Listen for fullscreen changes
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement)
    }
    document.addEventListener("fullscreenchange", handleFullscreenChange)
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange)
    }
  }, [])

  if (!model) {
    return (
      <Card
        style={{
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        }}
      >
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <Text type="secondary">اطلاعات پرونده در دسترس نیست</Text>
          }
        />
      </Card>
    )
  }

  return (
    <div id="mapFormWrapper">
      <Card
        style={{
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          overflow: "hidden",
        }}
        styles={{
          body: { padding: matches_sm ? 8 : 16 },
        }}
      >
        {/* Header */}
        <Flex
          justify="space-between"
          align="center"
          wrap="wrap"
          gap={8}
          style={{
            marginBottom: 12,
            paddingBottom: 12,
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Flex align="center" gap={8}>
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: 8,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FileTextOutlined style={{ color: "#fff", fontSize: 18 }} />
            </div>
            <div>
              <Title level={5} style={{ margin: 0, fontSize: matches_sm ? 14 : 16 }}>
                فرم نقشه گازرسانی
              </Title>
              {model?.gasProject?.fileNumber && (
                <Text type="secondary" style={{ fontSize: 12 }}>
                  شماره پرونده: {model.gasProject.fileNumber}
                </Text>
              )}
            </div>
          </Flex>

          <Flex gap={8} wrap="wrap">
            <Tag
              color="blue"
              style={{
                borderRadius: 6,
                padding: "2px 8px",
                fontSize: 11,
              }}
            >
              <PrinterOutlined style={{ marginLeft: 4 }} />
              قابل چاپ
            </Tag>
            
            <Button
              type="text"
              size="small"
              icon={<ReloadOutlined />}
              onClick={reloadReport}
              style={{ borderRadius: 6 }}
            >
              {!matches_sm && "بارگذاری مجدد"}
            </Button>

            {!matches_sm && (
              <Button
                type="text"
                size="small"
                icon={isFullscreen ? <CompressOutlined /> : <ExpandOutlined />}
                onClick={toggleFullscreen}
                style={{ borderRadius: 6 }}
              >
                {isFullscreen ? "خروج" : "تمام صفحه"}
              </Button>
            )}
          </Flex>
        </Flex>

        {/* Report Container */}
        <div
          style={{
            position: "relative",
            minHeight: matches_sm ? 400 : 600,
            maxHeight: matches_sm ? "70vh" : "850px",
            background: "#fafafa",
            borderRadius: 8,
            overflowX: "scroll", // Always show horizontal scroll
            overflowY: "auto",
            WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS
          }}
        >
          {/* Loading Overlay */}
          {isLoading && (
            <Flex
              justify="center"
              align="center"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(255,255,255,0.9)",
                zIndex: 10,
                borderRadius: 8,
              }}
            >
              <Flex vertical align="center" gap={12}>
                <Spin size="large" />
                <Text type="secondary">در حال بارگذاری گزارش...</Text>
              </Flex>
            </Flex>
          )}

          {/* Error State */}
          {hasError && !isLoading && (
            <Flex
              justify="center"
              align="center"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "#fff",
                zIndex: 10,
                borderRadius: 8,
              }}
            >
              <Empty
                description={
                  <Flex vertical align="center" gap={8}>
                    <Text type="secondary">مشکل در بارگذاری فرم</Text>
                    <Button
                      type="primary"
                      size="small"
                      icon={<ReloadOutlined />}
                      onClick={reloadReport}
                      style={{
                        borderRadius: 6,
                        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        border: "none",
                      }}
                    >
                      تلاش مجدد
                    </Button>
                  </Flex>
                }
              />
            </Flex>
          )}

          {/* Stimulsoft Report Viewer */}
          <div
            id="mapForm"
            style={{
              direction: "ltr",
              width: matches_sm ? "1600px" : "1600px", // Fixed width on mobile to force scroll
              minHeight: matches_sm ? 400 : 600,
            }}
          />
        </div>

        {/* Mobile Scroll Hint */}
        {matches_sm && (
          <Flex
            justify="center"
            style={{
              marginTop: 12,
              padding: "8px 12px",
              background: "#f5f5f5",
              borderRadius: 8,
            }}
          >
            <Text type="secondary" style={{ fontSize: 11, textAlign: "center" }}>
              👆 برای مشاهده کامل، به چپ و راست بکشید | 🔄 برای مشاهده بهتر، دستگاه را بچرخانید
            </Text>
          </Flex>
        )}
      </Card>
    </div>
  )
}

export default MapForm
